import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Row, Col} from 'react-bootstrap'
import {max, average} from '../../core/mathz'
import Card from '../../core/components/Card'
import Rating from '../../core/components/Rating'
import Icon from '../../core/components/Icon'
import i18n from '../i18n'
import style from './AnswerCard.less'

function questionAggregator(question) {
    return {question}
}

function answerAggregator(result, answer) {
    const aggrega = result.find((a) => a.question.uid == answer.questionUid)

    if (aggrega) {
        aggrega.answer = answer
    } else {
        console && console.warn('Question ' + answer.questionUid + ' doesn\'t exist')
    }
    return result
}

class AnswerCard extends Component {
    static propTypes = {
        campaign: PropTypes.object.isRequired,
        answer: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
            aggregation: []
        }
    }

    componentWillMount() {
        const {campaign, answer} = this.props

        const maxScore = max({source: campaign.notationScale, identify: (s) => s.position})
        const averageScore = average({source: answer.answers, identify: (a) => a.score, accuracy: 0.1})
        const questionAggregation = campaign.questions.map(questionAggregator).reverse()
        const aggregation = answer.answers.reduce(answerAggregator, questionAggregation)
        this.setState({maxScore, averageScore, aggregation})
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.campaign != this.props.campaign
            || nextProps.answer != this.props.answer) {
            const {campaign, answer} = nextProps

            const maxScore = max({source: campaign.notationScale, identify: (s) => s.position})
            const averageScore = average({source: answer.answers, identify: (a) => a.score, accuracy: 0.1})
            const questionAggregation = campaign.questions.map(questionAggregator).reverse()
            const aggregation = answer.answers.reduce(answerAggregator, questionAggregation)
            this.setState({maxScore, averageScore, aggregation})
        }
    }

    _toggle() {
        const {expanded} = this.state
        this.setState({expanded: !expanded})
    }

    _navigate(event, path) {
        const {dispatch} = this.props

        event.preventDefault()
        dispatch(push(path))
    }

    render() {
        const {campaign, answer, ...others} = this.props
        const {maxScore, averageScore, aggregation, expanded} = this.state

        const header = (
            <h5>{i18n.answer}</h5>
        )

        const help = (
            <div>
                <strong>Ticket</strong>
                <a
                    href=''
                    onClick={(e) => this._navigate(e, '/tickets/' + answer.ticketUid)}>
                    <span> {answer.ticketUid}</span>
                </a>
            </div>
        )

        return (
            <Card
                kind='tab'
                header={header}
                help={help}
                onClick={() => this._toggle()}
                {...others}>
                <Row>
                    <Col sm={6}>
                        <Rating
                            label={i18n.score}
                            range={maxScore}
                            value={averageScore} />
                    </Col>
                    <Col sm={6}>
                        <div className={style.caller}>
                            <h5>
                                <span>{answer.caller.name.firstName}</span>
                                <span> {answer.caller.name.lastName}</span>
                                <span>{answer.caller.name.value}</span>
                            </h5>
                        </div>
                    </Col>
                </Row>
                {expanded && (
                    <div>
                        <ul className={style.questionGroup}>
                            {aggregation.map((aggrega) => (
                                <li
                                    key={aggrega.question.uid}>
                                    <h4>{aggrega.question.text}</h4>
                                    <Row>
                                        <Col sm={6}>
                                            <Rating
                                                label={i18n.score}
                                                range={maxScore}
                                                value={aggrega.answer.score} />
                                        </Col>
                                        <Col sm={6}>
                                            {aggrega.answer.comment && (
                                                <p>
                                                    <Icon icon='quote' size='xs' />
                                                    <span>{aggrega.answer.comment}</span>
                                                </p>
                                            )}
                                        </Col>
                                    </Row>
                                </li>
                            ))}
                        </ul>
                        {answer.comment && (
                            <div className={style.globalComment}>
                                <h4>{i18n.globalComment}</h4>
                                <Row>
                                    <Col sm={6}>
                                    </Col>
                                    <Col sm={6}>
                                        <p>
                                            <Icon icon='quote' size='xs' />
                                            <span>{answer.comment}</span>
                                        </p>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </div>
                )}
            </Card>
        )
    }
}

AnswerCard = connect()(AnswerCard)

export default AnswerCard


// WEBPACK FOOTER //
// ./lib/satisfaction/components/AnswerCard.js